import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';

const TOKEN_KEY = 'auth-token';
const REFRESHTOKEN_KEY = 'auth-refreshtoken';
const USER_KEY = 'auth-user';
const EXPIRYTOKEN_KEY = 'auth-expiryToken';
const FAMILY_NAME = 'family_name';
@Injectable({
  providedIn: 'root'
})
export class TokenStorageService {
  header: { headers: any; };
  constructor() { }

  signOut(): void {
    window.sessionStorage.clear();
  }

  public saveToken(token: string): void {
    window.sessionStorage.removeItem(TOKEN_KEY);
    window.sessionStorage.setItem(TOKEN_KEY, token);

    const user = this.getUser();
    if (user.id) {
      this.saveUser({ ...user, accessToken: token });
    }
  }
  public saveExpiryToken(token: any): void {
    window.sessionStorage.removeItem(EXPIRYTOKEN_KEY);
    window.sessionStorage.setItem(EXPIRYTOKEN_KEY, token);
  }
  public getExpiryToken(): any | null {
    return window.sessionStorage.getItem(EXPIRYTOKEN_KEY);
  }
  public getToken(): string | null {
    return window.sessionStorage.getItem(TOKEN_KEY);
  }

  public saveRefreshToken(token: any): void {
    window.sessionStorage.removeItem(REFRESHTOKEN_KEY);
    window.sessionStorage.setItem(REFRESHTOKEN_KEY, token);
  }

  public getRefreshToken(): any | null {
    return window.sessionStorage.getItem(REFRESHTOKEN_KEY);
  }

  public saveUser(user: any): void {
    window.sessionStorage.removeItem(USER_KEY);
    window.sessionStorage.setItem(USER_KEY, JSON.stringify(user));
  }
  public saveGroup(group: any) {
    window.sessionStorage.removeItem(FAMILY_NAME);
    window.sessionStorage.setItem(FAMILY_NAME, group);
  }
  
  public getGroup(): any | null {
    return window.sessionStorage.getItem(FAMILY_NAME)
  }

  public getUser(): any {
    const user = window.sessionStorage.getItem(USER_KEY);
    if (user) {
      return JSON.parse(user);
    }
    else{
      return {};
    }
  }
  public createHttpOptions(){
    return {
      headers : new HttpHeaders().append('Authorization', this.getToken())
    }
  }
}